import NavigationEntry from './NavigationEntry';
import './Navigation.css'
import { Swiper, SwiperSlide } from 'swiper/react';

function Navigation(props) {
    return (
        <div className="navigation" id='projectsNavigation'>
            <div className='swiper-container double-line-height'>
                <Swiper
                    className='swiper'
                    style={{ height: '100%' }}
                    allowTouchMove={false}
                    loop={true}
                    onSwiper={(swiper) => {
                        props.setNavigationSwiper(swiper);
                    }}
                    slidesPerView={'auto'}
                    autoHeight={true}
                    direction='vertical'
                    initialSlide={props.swiperIndex}
                    centeredSlides={true}
                >
                    {[...props.projectMetas, ...props.projectMetas].map((folder, index) => (
                        <SwiperSlide className='swiper-slide-s' key={index}>
                            <NavigationEntry swiperIndex={props.swiperIndex} folder={folder} index={index} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default Navigation;